/* eslint-disable @typescript-eslint/ban-types */
import React from 'react'
import {
  renderHelpersText,
  renderErrorInField,
  renderUpdatedInField,
} from '@flatsy/utils/Functions/form/Helpers'
import GooglePlaceAutoComplete from '../../../../../Global/Gmap/GooglePlaceAutoComplete'
import { FieldsType, SingleFieldProps } from '../../../../Types'

const Address = <T extends {}>({
  field,
  input,
  meta,
  values,
  justSubmitted,
}: SingleFieldProps<T>): React.ReactElement => {
  /**
   * @description render label or condition label
   * @param field
   * @param values
   */
  const renderLabelInField = (field: FieldsType, values: T) => {
    return field.conditional ? field.conditional(values).label : field.label
  }

  return (
    <GooglePlaceAutoComplete
      error={renderErrorInField(meta)}
      updated={renderUpdatedInField(meta, justSubmitted)}
      helperText={renderHelpersText(field, meta.touched, meta.error, meta.submitError)}
      label={renderLabelInField(field, values)}
      initialValue={field.addressInitialValue || undefined}
      testid="form-field-address"
      {...input}
      onChange={(e, v) =>
        input.onChange({
          id: v?.place_id,
          description: v?.description,
        })
      }
    />
  )
}

export default Address
